import React from 'react'
import {Box, Card, CardActionArea, CardContent, Typography} from "@mui/material";
import useStyles from "../../assets/styles/HomeStyles";
import AlignmentLogo from '../../assets/images/DQ-Aligment.png'
import CreatorLogo from '../../assets/images/DQ-Learning.png'
import AssessmentLogo from '../../assets/images/DQ-Assessment.png'
import FrameworkLogo from '../../assets/images/DQ-Framework.png'
import {Button} from "@material-ui/core";
 const Home= ({ actions })=>{

    const {navigateToProgramCreator,
        navigateToFrameworkCreator,
        navigateToReportTypes,
        navigateToAssessmentCreator,
        navigateToDQGuide } = actions;

     const classes = useStyles();
     const cardData = [
         {
             image: AlignmentLogo,
             title: (
                 <>
                     DQ Stars<br /> Alignment
                 </>
             ),
             description: 'Validate your program through alignment with 100+ global digital literacy standards and frameworks.',
             // points: ['Shows all aligned DQ Codes with definitions',
             //     'Shows all frameworks and digital skills agenda potentially aligned with',
             //     'Shows areas for potential enhancements',
             //     'Shows potential cyber-risks your program can address (for child online safety, digital literacy, or cyber citizenship programs)'],
             action: navigateToReportTypes,
             buttonText: 'Validate Program',
             disabled: false
         },
         {
             image: AssessmentLogo,
             title: (
                 <>
                     DQ Assessment <br /> Creator
                 </>
             ),
             description: 'Create credible, data-driven assessments - powered by a global databank of benchmarks.',
             // points: ['Curated assessment based on your learning content',
             //     'Create pre and post assessments for impact tracking',
             //     'Analytics dashboard to monitor learner progress and efficacy',
             //     'Integrate via API or direct assessment link'
             // ],
             action: navigateToAssessmentCreator,
             buttonText: 'Create Assessment',
             disabled: false
         },
         {
             image: CreatorLogo,
             title: (
                 <>
                     DQ Learning <br /> Creator
                 </>
             ),
             description: 'Develop your own digital literacy learning program - fully aligned with global standards and best practices.',
             //             points: ['Build a fully curated program with learning content',
             //                 'Integrate via API or direct program link',
             //                 'Generate PPT and PDF versions of learning content',
             //                 'Generates graphics, images, and videos based on your program content',
             // ],
             action: navigateToProgramCreator,
             buttonText: 'Create Learning Content',
             disabled: false
         },
         {
             image: FrameworkLogo,
             title: (
                 <>
                     DQ Framework <br /> Creator
                 </>
             ),
             description: 'Design your own digital literacy framework - backed by 100+ global standards and frameworks.\n',
             // points: ['Conformity test of existing program (if any)',
             //     'Generates standardized framework mapped with DQ Codes and definitions based on IEEE DQ Global Standards (IEEE3527.1TM)',
             //     'Easily create assessments and programs based off of this framework'],
             action: navigateToFrameworkCreator,
             buttonText: 'Coming Soon',
             disabled: true
         },
     ];
    return(
        <>
            <Box className={classes.pageContainer}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'55px', sm:'0px'} }} className={classes.title}>
                    Welcome to Powered by DQ
                </Typography>
                <Typography variant="h7" sx={{ textAlign: "center", marginBottom:{sm:2, xs:1}, marginTop:{xs:'55px', sm:'0px'} }} className={classes.subtitle}>
                    Select a Tool to Start
                </Typography>

                <Box className={classes.cardsContainer} sx={{flexDirection: { xs: "column", sm: "row" },}}>
                    {cardData.map((card, index) => (
                        <Card key={index} className={classes.card} onClick={card.action}>
                                <CardContent className={classes.cardContent}>
                                    {console.log(card.image)}
                                    {card.image && (typeof card.image === 'string' && !card.image.includes('.')) ? (
                                        <Typography variant="h6" className={classes.cardText}>
                                            {card.image}
                                        </Typography>
                                    ) : (
                                        <img src={card.image} className={classes.cardImage} alt="Card Image" />
                                    )}

                                    <Typography variant="h5" mt="1" style={{fontWeight:'bold', marginTop:'20px', color:'#ff6468ff'}}>
                                        {card.title}
                                    </Typography>

                                    <Typography variant="body1" paragraph style={{padding: '10px 30px',marginTop:'20px',marginLeft:'10px', height: '100px', textAlign: 'center', color:'#000000'}}>
                                        {card.description.split('IEEE3527.1TM').map((part, index, array) => (
                                            <React.Fragment key={index}>
                                                {part}
                                                {index !== array.length - 1 && (
                                                    <>
                                                        IEEE3527.1<sup>TM</sup>
                                                    </>
                                                )}
                                            </React.Fragment>
                                        ))}
                                        </Typography>
                                    <Box textAlign="center" mt={2}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={card.disabled}
                                            onClick={!card.disabled ? card.action : undefined}
                                            className={classes.cardButton}
                                        >
                                            {card.buttonText}
                                        </Button>
                                    </Box>
                                        {/*<ul>*/}
                                        {/*    {card.points.map((point, idx) => (*/}
                                        {/*        <li key={idx} className={classes.listItemText}>*/}
                                        {/*            {point.split('IEEE3527.1TM').map((part, index, array) => (*/}
                                        {/*                <React.Fragment key={index}>*/}
                                        {/*                    {part}*/}
                                        {/*                    {index !== array.length - 1 && (*/}
                                        {/*                        <>*/}
                                        {/*                            IEEE3527.1<sup>TM</sup>*/}
                                        {/*                        </>*/}
                                        {/*                    )}*/}
                                        {/*                </React.Fragment>*/}
                                        {/*            ))}*/}
                                        {/*        </li>*/}
                                        {/*    ))}*/}
                                        {/*</ul>*/}
                                </CardContent>
                        </Card>
                        ))}
                </Box>
            </Box>
        </>
    )
 }

export default Home;